
import StatsCard from "@/components/StatsCard";
import { FileCheck, Bell, Clock } from "lucide-react";

interface StatsCardsProps {
  statsCards: Array<{
    title: string;
    value: string;
    description: string;
    icon: any;
    trend?: { value: number; isPositive: boolean };
  }>;
}

const StatsCards = ({ statsCards }: StatsCardsProps) => {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      {statsCards.map((card, i) => (
        <StatsCard key={i} {...card} />
      ))}
    </div>
  );
};

export default StatsCards;
